import $ from 'jquery';
import 'slick-carousel';

const SLICK_OPTIONS = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 450,
    slidesToShow: 1,
    adaptiveHeight: true,
};

class Carousel {
    constructor() {
        $('.carousel').slick(SLICK_OPTIONS);
    }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/js/components/carousel.js